import {Button, ColourSolid, ColourOutline, PricingBlock, PricingBlockSummaryEntry} from "@twigsby/frontend-framework";
import React from "react";
import {SignUpPlanSummaryInterface} from "../../Types/SignUp/SignUpSection";
import SignUpSectionHeader from "./SignUpSectionHeader";

const Summary: React.FC<SignUpPlanSummaryInterface> = (props) => {
    const monthlyCost = props.selectedPlan ? props.selectedPlan?.cost + (props.selectedLetterPlan ? props.selectedLetterPlan?.cost : props.selectedParcelPlan ? props.selectedParcelPlan.cost : 0.00) : 0.00;
    const annualCost = props.selectedPlan ? props.selectedPlan?.cost + (props.selectedLetterPlan ? props.selectedLetterPlan?.cost : props.selectedParcelPlan ? props.selectedParcelPlan.cost : 0.00) : 0.00;

    const HandleEditCallback = () => {
        if(props.onEditCallback) {
            props.onEditCallback();
        }
    }

    return (
        <div className={`sign-up-section ${props.visible ? 'mb-xxxl' : 'sign-up-section-hide'} ${props.complete && !props.visible ? 'sign-up-section-complete mt-xs' : 'mt-lg'}`}>
            <SignUpSectionHeader label={props.label} completeLabel={props.completeLabel} complete={props.complete} visible={props.visible} editCallBack={() => HandleEditCallback()} />

            <div className={'flex-row flex-wrap flex-gap-sm plan-wrapper'}>
                <PricingBlock title={'Monthly'} price={monthlyCost} extraInfo={'Flexible Payments '} callBackContent={<SelectBilling parentProps={props} itemProps={{id: 1, label: 'Monthly' }} />}>
                    <div className={'pricing-block-entries'}>
                        {props.selectedPlan && (
                            <PricingBlockSummaryEntry title={props.selectedPlan.label} extra={`£${props.selectedPlan.cost}`} />
                        )}
                        {props.selectedLetterPlan && (
                            <PricingBlockSummaryEntry title={props.selectedLetterPlan.labelExtra ?? props.selectedLetterPlan.label} extra={`£${props.selectedLetterPlan.cost}`} />
                        )}
                        {props.selectedParcelPlan && (
                            <PricingBlockSummaryEntry title={props.selectedParcelPlan.labelExtra ?? props.selectedParcelPlan.label} extra={`£${props.selectedParcelPlan.cost}`} />
                        )}
                    </div>
                </PricingBlock>

                {monthlyCost !== 0 && (
                    <PricingBlock title={'Annually'} price={annualCost * 10} extraInfo={'Two Months Free - Save 16%'} extraInfoColour={ColourOutline.Success} callBackContent={<SelectBilling parentProps={props} itemProps={{ id: 2, label: 'Annual' }} />}>
                        <div className={'pricing-block-entries'}>
                            {props.selectedPlan && (
                                <PricingBlockSummaryEntry title={props.selectedPlan.label} extra={`£${props.selectedPlan.cost * 10}`} />
                            )}
                            {props.selectedLetterPlan && (
                                <PricingBlockSummaryEntry title={props.selectedLetterPlan.labelExtra ?? props.selectedLetterPlan.label} extra={`£${props.selectedLetterPlan.cost * 10}`} />
                            )}
                            {props.selectedParcelPlan && (
                                <PricingBlockSummaryEntry title={props.selectedParcelPlan.labelExtra ?? props.selectedParcelPlan.label} extra={`£${props.selectedParcelPlan.cost * 10}`} />
                            )}
                        </div>
                    </PricingBlock>
                )}
            </div>

        </div>
    )
};

export default Summary;

export type SelectSummaryType = {
    itemProps: any;
    parentProps: SignUpPlanSummaryInterface;
}

const SelectBilling = (props: SelectSummaryType) => {
    const planSelected = props.parentProps.value === props.itemProps.id;

    const HandleCallBack = () => {
        if(props.parentProps.value === props.itemProps.id) {
            if(props.parentProps.onCancelCallback) {
                props.parentProps.onCancelCallback();
            }
        } else {
            if(props.parentProps.onChangeCallback) {
                props.parentProps.onChangeCallback(props.itemProps);
            }
        }
    }

    return (
        <Button title={planSelected ? 'Selected' : 'Select'} colour={planSelected ? ColourSolid.Selected : ColourSolid.Primary} fullWidth={true} onClick={() => HandleCallBack()} />
    )
}
